module.exports = __webpack_public_path__ + "static/media/praying.481412d6.png";